import React from 'react';
import { ICeBondsUser } from '../api/types';

//export const OktaUserContext = React.createContext<UserClaims | undefined>({ sub: "00u3wublp2w6vUs6W1d7" });  //impersonating Sri
export const CeBondsUserContext = React.createContext<ICeBondsUser | undefined>(undefined);
export const useCeBondsUserContext = () =>
  React.useContext<ICeBondsUser | undefined>(CeBondsUserContext);
